import styled from '@emotion/styled';
import { mediaQuery } from 'src/assets/media-query-config';
import { mainColors } from 'src/assets/colors';

export const LoginPageWrapper = styled('div', { label: 'LoginPageWrapper' })`
    display: flex;
    flex-flow: row nowrap;
    min-height: 100%;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    overflow-y: auto;
`;

export const LoginHeader = styled('h2', { label: 'LoginHeader' })`
    font-weight: 700;
    font-size: 32px;
    line-height: 1.25;
    margin: 48px 0 4px 0;
    color: ${mainColors.default.dark};
    letter-spacing: 0.32px;
`;

export const LoginText = styled('p', { label: 'LoginText' })`
    font-weight: 400;
    font-size: 14px;
    line-height: 1.42;
    margin: 0;
    color: ${mainColors.txtDark48};
`;

export const LoginBoxWrapper = styled('div', { label: 'LoginBoxWrapper' })`
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    background-color: ${mainColors.default.light};

    @media ${mediaQuery.desktop} {
        width: 50%;
    }
`;

export const LoginBox = styled('div', { label: 'LoginBox' })`
    min-width: 416px;
`;
